
<div class="nsw-content-block content-card">
	<div class="nsw-card nsw-card--highlight">
		<div class="nsw-card__content card-content">
			<div class="nsw-card__title">
				<ng-container *ngTemplateOutlet="isExternalLink ? external : internal;">
				</ng-container>					
			</div>
			<div class="nsw-card__copy">
				<p>{{description}}</p>
			</div>
			<span class="material-icons nsw-material-icons" focusable="false" aria-hidden="true">east</span>
		</div>
	</div>
</div>		

<ng-template #external>
	<a *ngIf="!link" href="javascript:void(0)" [attr.download]="download ? '' : null"> <span
			class="label">{{title}}</span></a>
	<a target="_blank" *ngIf="link" [href]="link" [attr.download]="download ? '' : null"><span
			class="label">{{title}}</span></a>
</ng-template>

<ng-template #internal>
	<a *ngIf="!link" href="javascript:void(0)" [attr.download]="download ? '' : null"><span
			class="label">{{title}}</span></a>
	<a *ngIf="link" [routerLink]="link" [attr.download]="download ? '' : null"><span class="label">{{title}}</span></a>
</ng-template>